import React, { useState } from "react";
import Swal from "sweetalert2";
import FiltroPanelLayout from "./FiltroPanelLayout";
import CampoFiltro from "./CampoFiltro";
import ListaChecksFiltro from "./ListaChecksFiltro";
import { useFiltroASD } from "./useFiltroASD";

// Capa 3: filtro reutilizable listo para usar.
// - campos: configuración de la tarjeta izquierda (ver CampoFiltro).
// - asd: { region, sucursal, departamento, sucursalesPermitidas } → columnas opcionales.
// - onAplicar(valores): valores de los campos + adr/sucursal/departamento (arreglos de ids).
// Fecha de creación: 2026-09-15 — Autor: IA (Claude)
const esVacio = (v) => v === null || v === undefined || (Array.isArray(v) ? v.length === 0 : String(v).trim() === "");

// Cuenta filtros con valor (útil para el numerito del botón "Filtrar").
export const contarFiltrosActivos = (valores = {}, ignorar = []) =>
  Object.entries(valores).filter(([clave, valor]) => !ignorar.includes(clave) && !esVacio(valor)).length;

const valoresVacios = (campos) => Object.fromEntries(campos.map((c) => [c.name, c.valorVacio ?? ""]));

const FiltroPanel = ({
  titulo = "Filtro",
  tituloAlerta = "FILTRO",
  campos = [],
  valores = {},
  asd,
  validar,
  onAplicar,
  onCerrar,
  textoAplicar = "Cargar",
  mostrarLimpiar = true,
}) => {
  const [borrador, setBorrador] = useState(() => ({ ...valoresVacios(campos), ...valores }));
  const usaASD = Boolean(asd && (asd.region || asd.sucursal || asd.departamento));
  const filtroASD = useFiltroASD({
    activo: usaASD,
    sucursalesPermitidas: asd?.sucursalesPermitidas,
    inicial: { adr: valores.adr, sucursal: valores.sucursal, departamento: valores.departamento },
  });

  const onCambiar = (name, valor) => setBorrador((prev) => ({ ...prev, [name]: valor }));

  const onCargar = () => {
    const faltante = campos.find((c) => c.requerido && esVacio(borrador[c.name]) && (!c.visible || c.visible(borrador)));
    if (faltante) {
      Swal.fire(tituloAlerta, faltante.mensajeRequerido || `Favor de seleccionar ${faltante.label.toLowerCase()}.`, "warning");
      return;
    }
    const resultado = usaASD ? { ...borrador, ...filtroASD.seleccion } : { ...borrador };
    const errorValidacion = validar ? validar(resultado) : null;
    if (errorValidacion) {
      Swal.fire(tituloAlerta, errorValidacion, "warning");
      return;
    }
    onAplicar && onAplicar(resultado);
  };

  const onLimpiar = () => {
    setBorrador(valoresVacios(campos));
    if (usaASD) filtroASD.limpiar();
  };

  const tarjeta = (
    <form
      className="filtro-panel-form"
      onSubmit={(e) => {
        e.preventDefault();
        onCargar();
      }}
    >
      {campos
        .filter((c) => !c.visible || c.visible(borrador))
        .map((campo) => (
          <CampoFiltro key={campo.name} campo={campo} valor={borrador[campo.name]} valores={borrador} onCambiar={onCambiar} />
        ))}
      <button type="submit" className="filtro-panel-btn-cargar">{textoAplicar}</button>
      {mostrarLimpiar && (
        <button type="button" className="filtro-panel-btn-limpiar" onClick={onLimpiar}>
          Limpiar
        </button>
      )}
    </form>
  );

  const vacioASD = filtroASD.cargando ? "Cargando..." : filtroASD.error ? "No fue posible cargar" : "Sin opciones";
  const columnas = usaASD
    ? [
        asd.region && (
          <ListaChecksFiltro titulo="Región" items={filtroASD.regiones} seleccionados={filtroASD.seleccion.adr}
            onToggle={(id) => filtroASD.toggle("adr", id)} vacio={vacioASD} />
        ),
        asd.sucursal && (
          <ListaChecksFiltro titulo="Sucursal" items={filtroASD.sucursales} seleccionados={filtroASD.seleccion.sucursal}
            onToggle={(id) => filtroASD.toggle("sucursal", id)} vacio={vacioASD} />
        ),
        asd.departamento && (
          <ListaChecksFiltro titulo="Departamento" items={filtroASD.departamentos} seleccionados={filtroASD.seleccion.departamento}
            onToggle={(id) => filtroASD.toggle("departamento", id)} vacio={vacioASD} />
        ),
      ]
    : [];

  return <FiltroPanelLayout titulo={titulo} onCerrar={onCerrar} tarjeta={tarjeta} columnas={columnas} />;
};

export default FiltroPanel;
